import Cookies from 'js-cookie'
import { UtilitiesInstance, env } from '@/store'
import { catchError } from '@/support/errorLogger.js'
import { setCookieCompany, updateCookieCompany } from '@/support/cookieCompany'

const nps = {
  state: {
    showNps: false
  },
  mutations: {
    setNps (state, showNps) {
      state.showNps = showNps
    }
  },
  getters: {
    showNps (state) {
      return state.showNps
    }
  },
  actions: {
    GET_NPS (context) {
      let cookieCompany = Cookies.get(`${env}mp_company`)
      if (cookieCompany) {
        Promise.resolve(atob(cookieCompany))
          .then(JSON.parse)
          .then(resCookieParse => {
            cookieCompany = resCookieParse
            if (cookieCompany.nps && Object.entries(cookieCompany.nps).length) {
              if (cookieCompany.nps.available) context.dispatch('VIEW_NPS')
              context.commit('setNps', cookieCompany.nps.available)
            } else {
              return UtilitiesInstance.nps
                .getMe()
                .then(res => {
                  if (res.available) context.dispatch('VIEW_NPS')
                  context.commit('setNps', res.available)
                  setCookieCompany({ nps: res })
                })
                .catch(err => {
                  // eslint-disable-next-line no-console
                  console.error('GET_NPS', err)
                })
            }
          })
      } else {
        return UtilitiesInstance.nps
          .getMe()
          .then(res => {
            if (res.available) context.dispatch('VIEW_NPS')
            context.commit('setNps', res.available)
            setCookieCompany({ nps: res })
          })
          .catch(err => {
            // eslint-disable-next-line no-console
            console.error('GET_NPS', err)
          })
      }
    },
    SET_ANSWER_NPS (context, body) {
      return UtilitiesInstance.nps
        .setAnswer(body)
        .then(res => Promise.resolve(res))
        .catch(err => catchError(err, context))
    },
    VIEW_NPS (context) {
      return UtilitiesInstance.nps
        .view()
        .then(res => Promise.resolve(res))
        .catch(err => catchError(err, context))
    },
    TOGGLE_NPS (context) {
      updateCookieCompany('nps')
      context.commit('setNps', !context.state.showNps)
    }
  }
}

export default nps
